import { render } from "./AccountAgreement.vue?vue&type=template&id=331d5375&scoped=true"
import script from "./AccountAgreement.vue?vue&type=script&lang=js"
export * from "./AccountAgreement.vue?vue&type=script&lang=js"

import "./AccountAgreement.vue?vue&type=style&index=0&id=331d5375&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-331d5375"

export default script